// Configuration file for application-specific settings
import { ApplicationConfiguration } from '@core/models';
import versions from './_versions';

export const config: ApplicationConfiguration = {
  apiURL: 'https://api.fpar2-clinic-locator.mathematica-dev.org',
  appDescription: 'FPAR Clinic Locator',
  appOwner: 'Mathematica',
  appTitle: 'CLDB',
  debugMode: true,
  googleApiKey: 'AIzaSyCpoLzek7x-olycRUW_PhdfCGy9O2T72jY',
  production: false,
  version: versions.version,
};
